import type { Ref } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import { IconButton } from "@mui/material";

interface FieldItemOptionsButtonProps {
  ref?: Ref<HTMLButtonElement>;
  hideOptions?: boolean;
  showOptions?: () => void;
}

const FieldItemOptionsButton = ({ ref, hideOptions, showOptions }: FieldItemOptionsButtonProps) => {
  return (
    <IconButton
      ref={ref}
      onClick={showOptions}
      disableFocusRipple
      sx={{ height: "30px", display: hideOptions === true ? "none" : "inherit" }}
    >
      <ChevronRightIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
    </IconButton>
  );
};

export default FieldItemOptionsButton;
